import { render, staticRenderFns } from "./textSearch.vue?vue&type=template&id=8bad7320&scoped=true&"
import script from "./textSearch.vue?vue&type=script&lang=js&"
export * from "./textSearch.vue?vue&type=script&lang=js&"
import style0 from "./textSearch.vue?vue&type=style&index=0&id=8bad7320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bad7320",
  null
  
)

export default component.exports